import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import InsightsSectionLastOrders from '../components/Insights/LastOrders'

import { actionCreators } from '../actions'

const mapStateToProps = (state) => ({
  profile: state.customer.profile,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InsightsSectionLastOrders)
